module.exports = __webpack_public_path__ + "img/login_bg.a668e310.png";